export const FieldsService = Symbol.for('FieldsService');
